var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"online"},[(_vm.isOnline)?_c('div',{staticClass:"people-online"}):_vm._e(),(!_vm.isOnline && _vm.getWasOnline)?_c('div',{staticClass:"people-offline"},[_c('img',{attrs:{"src":require("@/assets/images/icons/time.svg"),"alt":""}}),_c('p',[_vm._v("Был в сети "+_vm._s(_vm.getWasOnline))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }